import { AxiosRequestConfig } from 'axios';
import { forEachObjIndexed } from 'ramda';

const endpoint = '/api/apollo';

export default {
    getPolicy: (workflowId: string) =>
        ({
            method: 'GET',
            url: `${endpoint}/job/${workflowId}/policy`,
        } as AxiosRequestConfig),
    upload: (file: any, filename: string, config: any, onUploadProgressCallback?: (progressEvent: any) => void) => {
        const formData = new FormData();
        formData.append('key', `${config.prefix}/${filename}`);
        formData.append('file', file);

        forEachObjIndexed((value: any, key: any) => {
            formData.append(key, value);
        }, config.formData);

        return {
            url: config.postURL,
            method: 'POST',
            data: formData,
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            onUploadProgress: onUploadProgressCallback,
        } as AxiosRequestConfig;
    },
};
